import { FC } from 'react';

import { CurrentEntertainer, useCurrentEntertainerQuery } from '@queries/EntertainerQueries';

import { useCurrentUserCity } from '@hooks/useCurrentUserLocation';

import { createScreenComponent } from '@utilities/createScreenComponent';

import { Popup } from '@components/layout/Popup/Popup';
import { Screen } from '@components/layout/Screen';

import { FeaturedPhotoManagementSection } from '@screens/entertainer/components/FeaturedPhotoManagementSection';

export const ShareFeaturedLookCollabPostScreen = createScreenComponent<{ cityId?: string }>(
  ({ cityId, back }) => {
    const { currentCity } = useCurrentUserCity();
    const { entertainer } = useCurrentEntertainerQuery();

    const handleShareLook = (media: CurrentEntertainer['featuredMedia'][number]) => {
      console.log(media);
    };

    return (
      <Screen
        name="Share Featured Look Collab Post Screen"
        hideToolbar
        disableLocationPermissionGate
        headerProps={{
          back: { to: back ?? '/challenges' },
          title: <Screen.GagglTitle />,
        }}
      >
        <Screen.Content maxWidth={425}>
          <FeaturedPhotoManagementSection
            hideTitleToolbar
            cityId={cityId ?? currentCity?._id}
            featuredMedia={entertainer?.featuredMedia ?? []}
            shareLookOverride={handleShareLook}
          />
        </Screen.Content>
      </Screen>
    );
  },
);
